import React from 'react';
import ReactDOM from 'react-dom';
import LoginForm from '../Components/Login/LoginForm';

const loginFormContainer = document.querySelectorAll('.js-login-form') as NodeListOf<HTMLElement>;

const LoginFormIntegrations: React.FunctionComponent = (props) => {
    if (loginFormContainer.length > 0) {
        return (
            <>
                {[...loginFormContainer].map((loginFormDom) => {
                    return ReactDOM.createPortal(<LoginForm />, loginFormDom);
                })}
            </>
        );
    }

    return null;
};

export default LoginFormIntegrations;
